export default __webpack_public_path__ + "fc737f51d5965f320d77ab611255d2ac.svg";